import ComHttp from '@/common/Http'
import Http from '@/bll/Http'
import { HttpMethod, getApiUrl } from '@/config/http.config'
import { router } from '@/router'
/**
 * 获取token（各端给路由传的token）
 */
export async function getToken() {
  const token = router.currentRoute.value.params.token
  return new Promise((resolve) => {
    const res = token
      ? [
          null,
          {
            data: {
              status: 'success',
              data: token
            }
          }
        ]
      : [
          null,
          {
            data: {
              status: 'error',
              data: null
            }
          }
        ]
    resolve(res)
  })
}

/**
 * 获取Token，应用中心用于鉴权
 */
export async function getAuthToken(params) {
  const obj = {
    method: HttpMethod.GET,
    name: '应用中心获取Token',
    key: 'getAuthToken',
    url: getApiUrl('platformApi') + 'api/v1/Token',
    params,
    isCache: false,
    showLoading: false
  }
  const http = new ComHttp(obj)
  const data = await http.request()
  return data
}
